<template>
  <v-container fluid pa-5>
    <v-card
      class="mx-auto"
      max-width="344"
    >
      <v-card-text>
        <div>
          You are not authorized to view this page
        </div>
        <div class="text--primary">
          Click here to <a :href="defaultRoute">Go Back</a>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { dashboardRoute } from '@/lib/constants/routes'

export default {
  data () {
    return {
    }
  },
  computed: {
    defaultRoute () {
      return dashboardRoute.url
    }
  }
}
</script>

<style>

</style>
